<template>
    <div class="proLinkBox">
        <div class="links">
            <div class="linkTitle"><b>Learn more</b></div>
            <div style="padding-top:12px;color:#fff;">
                <a href="">MIS LYNX Catalog</a><br/>
                <a href="">MIS LYNX Flyer</a><br/>
                <a href="">Conical Connection Product Catalog</a><br/>
                <a href="">MIS LYNX Prosthetic Options</a>
            </div>
        </div>
        <a class="btn">View products </a>
    </div>      
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  components: {  },
  data() {
    return {
        items:[
        ]
    };
  },
  props: {
    sectionData:{}
  },
  computed: {
    ...mapGetters(["localeString"]),
  },
  methods: 
  {
    //...mapActions(["setGalleryIndex", "setGalleryChildren"]),
  }
};
</script>

<style scoped>

    .proLinkBox
    {      
      width: 100%;
      min-height: 10vw;      
      margin: auto;
      border-radius: 18px;
      padding: 40px 40px 45px 40px;
      background-color:#1894e2;color: #fff;
      /* border: solid 1px #202020;backdrop-filter: blur(5px); */
    }
    .proLinkBox .btn
    {
        
        font-weight: 500 !important;
        border-radius: 30px;
        padding: 10px 20px;
        /* border: solid 2px #202020;  color: #202020;     */
        border: solid 2px #fff;  
        color: #fff;
        font-size: 12px;
    }
    .proLinkBox .links
    {
      display: block;
      padding-bottom: 50px;
    }
    .proLinkBox .links a
    {
      color: #fff;
      font-size: 12px;
      font-weight: 300 !important;
      opacity: 0.8;
    }
    .proLinkBox .links .linkTitle
    {
      font-size: 18px !important;
    }


    @media (hover: hover) {
      .proLinkBox .links a:hover
      {
        opacity: 1;
      }

    }

    @media screen and (max-width: 815px)
    {
    }

    @media only screen and (min-width:2000px)
    {
    }
</style>
